import { SaveClientFlags } from '@sdk/authentication/types';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import getUserGeo from '@sdk/utils/api/getUserGeo';

// spreadsheet url: https://docs.google.com/spreadsheets/u/3/d/1dTpaaXvv5gKYPr_OVX8-zfd8ZgwROuq3iP8SZ_xhelc/edit?usp=sharing&pli=1
const FORM_URL =
  'https://script.google.com/macros/s/AKfycbzFFc1x8wAzt-ViK8pOslv6GqG-BsxPfqpFdI4dM5Pypk2OUBM/exec';
const SURVEY_FLAG_KEY = 'afterSignupSurvey1';

type SurveyFormData = {
  user_id: string;
  user_name: string;
  email: string;
  org_id: string;
  org_name: string;
  org_creation: string;
  industry: string;
  org_size: string;
  comment_1: string;
  comment_2: string;
  country_name: string;
};

type SurveyFeedback = {
  comment1: string;
  comment2: string;
};

type AdditionalFeedbackData = {
  user: AuthUserType;
  saveClientFlags: SaveClientFlags;
};

export async function sendSurveyFeedback(
  feedback: SurveyFeedback,
  additionalData: AdditionalFeedbackData
): Promise<void> {
  const geo = await getUserGeo();
  const data = getFormData(feedback, additionalData, geo.country);

  fetch(`${FORM_URL}?${new URLSearchParams(data)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  updateSurveyDisplayed(additionalData.saveClientFlags);
}

function getFormData(
  feedback: SurveyFeedback,
  additionalData: AdditionalFeedbackData,
  country: string
): SurveyFormData {
  const { user } = additionalData;
  const dismissedLabel = '**dismissed**';

  return {
    user_id: String(user.id),
    org_id: String(user.org.id),
    user_name: user.fullname,
    email: user.email,
    org_name: user.org.name,
    industry: user.org.businessCategory,
    org_creation: String(user.org.createdAt).substr(0, 10),
    org_size: String(user.settings.clientFlags.employeesCount),
    comment_1: feedback.comment1 || dismissedLabel,
    comment_2: feedback.comment2 || dismissedLabel,
    country_name: country,
  };
}

export function updateSurveyDisplayed(saveClientFlags: SaveClientFlags): void {
  saveClientFlags({ flags: { [SURVEY_FLAG_KEY]: new Date().toISOString() } });
}

export function shouldDisplaySurvey(user: AuthUserType): boolean {
  const wasDisplayed = !!user.settings.clientFlags[SURVEY_FLAG_KEY];
  return !wasDisplayed && !!user.settings.clientFlags?.canShowSurvey1;
}
